import { Slot } from '@radix-ui/react-slot'
import { cn } from '@workspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-elevated text-white',
        primary: 'bg-[#f97316] text-white',
        secondary: 'bg-elevated text-muted-foreground',
        outline: 'border border-border bg-transparent text-white',
        'outline-primary': 'border border-[#f97316]/40 bg-[#f97316]/10 text-[#f97316]',
        success: 'bg-emerald-600 text-white',
        warning: 'bg-amber-600 text-white',
        purple: 'bg-purple-600 text-white',
        destructive: 'bg-red-600 text-white',
      },
      size: {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-2.5 py-1 text-xs',
        lg: 'px-3 py-1.5 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
)

function Badge({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> &
  VariantProps<typeof badgeVariants> & {
    asChild?: boolean
  }) {
  const Comp = asChild ? Slot : 'span'

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
